import React, { SetStateAction, useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { TabSettingPageProps } from 'types/TabSettingPageProps';

interface TabsSettingsProps {
	tabsList: TabSettingPageProps[];
	setTabsList: React.Dispatch<SetStateAction<TabSettingPageProps[]>>;
}

export default function TabsSettings({
	tabsList,
	setTabsList
}: TabsSettingsProps) {
	const { t }: any = useTranslation();
	const [frsGrid, setFrsGrid] = useState('');

	function selectTab(id: number) {
		const tabsListCopy = structuredClone(tabsList);
		const newList = tabsListCopy.map((item: TabSettingPageProps) => {
			if (item.id === id) {
				item.isSelected = true;
			} else {
				item.isSelected = false;
			}
			return item;
		});
		setTabsList(newList);
	}

	function coutQtdFrsGrid() {
		let value = 0;
		if (tabsList.length > 0) {
			tabsList.forEach(() => {
				value = value + 1;
			});
		}
		return value;
	}

	function generateFrs(qtd: number) {
		let text = '';

		for (let i = 1; i <= qtd; i++) {
			if (i === 0) {
				text = '1fr';
			} else {
				text = `${text} 1fr`;
			}
		}

		setFrsGrid(text);
	}

	useLayoutEffect(() => {
		const qtdFrs = coutQtdFrsGrid();
		if (qtdFrs > 0) {
			generateFrs(qtdFrs);
		}
	}, [tabsList]);

	return (
		<S.container
			$qtdColumns={frsGrid}
			data-testid="conatiner-tabs-flags-settings"
		>
			{tabsList.length > 0 &&
				tabsList.map((item: TabSettingPageProps) => (
					<S.itemTab
						key={item.id}
						$isSelected={item.isSelected || false}
						onClick={() => selectTab(item.id)}
					>
						<S.titleTab $isSelected={item.isSelected} data-testid="itemTabs">
							{t(item.name)}
						</S.titleTab>
					</S.itemTab>
				))}
		</S.container>
	);
}
